module.exports = "../../app/cells/pages/landing_playground/index/topics_cell.rb";